// @flow
import { getSocket } from '../../utils/getSocket';
import { reconnectToWebSocket } from '../session/socket';

type EnumMessage = 'announcement';

export const scribeRogerVoiceMessage = (messageId: EnumMessage) => async (dispatch: Function, getState: Function) => {
  const { conversationEnded } = getState().scribeConversation;
  if (conversationEnded) return;
  await reconnectToWebSocket()(dispatch, getState);

  const insertPayload = {
    type: 'play-message',
    data: {
      messageId,
    },
  };

  const socket = getSocket();
  socket.send(JSON.stringify(insertPayload));
};
